import React from "react";
import { SORT_DIRECTIONS } from "constants/UI";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

function SortButton({ sortKey, currentSortKey, currentSortOrder, onClick }) {
  function handleClick() {
    if (onClick) {
      let newOrder = SORT_DIRECTIONS.ASC;
      let newKey = sortKey;
      if (currentSortKey === sortKey) {
        if (currentSortOrder === SORT_DIRECTIONS.ASC) {
          newOrder = SORT_DIRECTIONS.DESC;
        } else {
          newKey = "";
        }
      }

      onClick({
        sortKey: newKey,
        sortOrder: newOrder,
      });
    }
  }

  return (
    <button
      type="button"
      className="focus:outline-none relative px-2 text-sm text-gray-500"
      onClick={handleClick}
    >
      <FaSort />
      {sortKey === currentSortKey && (
        <div
          className="absolute top-0 text-gray-800"
          style={{ left: "0.5rem" }}
        >
          {currentSortOrder === SORT_DIRECTIONS.ASC ? (
            <FaSortUp />
          ) : (
            <FaSortDown />
          )}
        </div>
      )}
    </button>
  );
}

export default SortButton;
